import React, { useState, useEffect } from "react";
import { Navbar, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import "./Common.css";
import { kc } from "../config.js";

import bwLogo from "../pages/images/bw.png";
import bwcloudLogo from "../pages/images/bwcloud.png";
import nfdiLogo from "../pages/images/nfdi.png";

// Sandwich menu component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="navbar-toggler d-block custom-sandwich-btn"
  >
    <span className="navbar-toggler-icon"></span>
  </button>
));

const LandingPage = () => {
  const [markdownContent, setMarkdownContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [identityProviders, setIdentityProviders] = useState([
    {label: "Login"}
  ]);

  useEffect(() => {
    // Fetch Markdown Content
    fetch("/landing-page-content.md")
      .then((response) => {
        if (!response.ok)
          throw new Error("Could not find landing-page-content.md");
        return response.text();
      })
      .then((text) => {
        setMarkdownContent(text);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error loading markdown:", error);
        setMarkdownContent("### Welcome to Open Source VDI - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - <mark>THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!</mark> - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!");
        setIsLoading(false);
      });

    // Fetch Identity Providers
    fetch("/config.json")
      .then((response) => {
        if (!response.ok) throw new Error("Could not find config.json");
        return response.json();
      })
      .then((data) => {
        if (data.identity_providers) {
          setIdentityProviders(data.identity_providers);
        }
      })
      .catch((error) => {
        console.warn("Falling back to default IdPs:", error);
      });
  }, []);

  const handleLogin = (idpHint) => {
    if (idpHint) {
      kc.login({ idpHint });
    } else {
      kc.login();
    }
  };

  return (
    <div className="landing-main-bg">
      {/* Header */}
      <Navbar className="landing-navbar">
        <div className="d-flex align-items-center">
          {/* Tooltip '?' Button */}
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tooltip-landing">
                This is the landing page of the OSVDI project.
                <br />
                Scroll down to learn more about the project and how to contact
                us.
                <br />
                Click the login buttons to access the platform.
              </Tooltip>
            }
          >
            <button className="help-icon-btn">?</button>
          </OverlayTrigger>
        </div>

        {/* Sandwich Menu */}
        <Dropdown align="end" className="ms-auto">
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />
          <Dropdown.Menu className="custom-dropdown-menu">
            <Dropdown.Item
              href="https://www.bw-cloud.org"
              target="_blank"
              rel="noreferrer"
            >
              FAQ
            </Dropdown.Item>
            <Dropdown.Item
              href="https://rz.uni-freiburg.de/de"
              target="_blank"
              rel="noreferrer"
            >
              About us
            </Dropdown.Item>
            {process.env.REACT_APP_SOURCE_URL && (
              <Dropdown.Item
                href={process.env.REACT_APP_SOURCE_URL}
                target="_blank"
                rel="noreferrer"
                title={
                  process.env.REACT_APP_BUILD_DATE
                    ? `Build time: ${process.env.REACT_APP_BUILD_DATE}`
                    : ""
                }
              >
                Source code
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Navbar>

      {/* Main Content Area */}
      <div className="container-fluid px-3 py-4 p-md-5">
        <div className="row g-4">
          {/* Left Side: Markdown Project Info */}
          <div className="col-12 col-lg-9 order-2 order-lg-1">
            <div className="content-card-left">
              {isLoading ? (
                <p className="loading-text">Loading content...</p>
              ) : (
                <ReactMarkdown>{markdownContent}</ReactMarkdown>
              )}
            </div>
          </div>

          {/* Right Side: Login Panel */}
          <div className="col-12 col-lg-3 order-1 order-lg-2">
            <div className="login-panel-right">
              {/* Logos */}
              <div className="logo-flex-container">
                <div className="logo-item bw">
                  <img src={bwLogo} alt="bw Logo" draggable="false" />
                </div>
                <div className="logo-item bwcloud">
                  <img src={bwcloudLogo} alt="bwCloud Logo" draggable="false" />
                </div>
                <div className="logo-item nfdi">
                  <img src={nfdiLogo} alt="nfdi Logo" draggable="false" />
                </div>
              </div>

              {/* Dynamic Alternating Login Buttons for external IdPs */}
              {identityProviders.map((idp, index) => {
                const isPrimaryStyle = index % 2 === 0;

                return (
                  <button
                    key={idp.kc_idp_hint}
                    onClick={() => handleLogin(idp.kc_idp_hint)}
                    className={
                      isPrimaryStyle
                        ? "login-btn-primary"
                        : "login-btn-secondary"
                    }
                  >
                    {idp.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
